import React, { useEffect, useState } from 'react'
import axios from 'axios'

export default function DoctorName() {
    const [data, setData] = useState([])
    useEffect(() => {
        axios.get("https://jsonplaceholder.typicode.com/users").then(
            response => setData(response.data)
        )
    }, [])
    return (
        <div className='p-3'>
            {data.map(item => <div className='row'>
                <div className='col-md-3'><p key={item.id}>{item.username}</p></div>
            </div>)}
        </div>
    )
}
